type GiftCurrency = "USD" | "Riel";

type GiftModalProps = {
  open: boolean;
  title: string;
  hint: string;
  cancelLabel: string;
  saveLabel: string;
  amountInput: string;
  onAmountChange: (value: string) => void;
  currencyInput: GiftCurrency;
  onCurrencyChange: (value: GiftCurrency) => void;
  inputError: string;
  onCancel: () => void;
  onSave: () => void;
};

export default function GiftModal({
  open,
  title,
  hint,
  cancelLabel,
  saveLabel,
  amountInput,
  onAmountChange,
  currencyInput,
  onCurrencyChange,
  inputError,
  onCancel,
  onSave,
}: GiftModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{ background: "var(--modal-backdrop)" }}
    >
      <div className="w-full max-w-sm rounded-2xl border border-[color:var(--field-border)] bg-[color:var(--surface)] p-6 shadow-[var(--modal-shadow)]">
        <h3 className="text-lg font-semibold text-[color:var(--foreground)]">{title}</h3>
        <p className="mt-2 text-sm text-[color:var(--muted)]">{hint}</p>
        <div className="mt-4 flex items-center gap-2">
          <input
            value={amountInput}
            onChange={(event) => onAmountChange(event.target.value)}
            onFocus={() => {
              if (amountInput.trim() === "0") {
                onAmountChange("");
              }
            }}
            inputMode="decimal"
            placeholder="0"
            className="w-full rounded-xl border border-[color:var(--field-border)] bg-[color:var(--surface)] px-4 py-3 text-sm text-[color:var(--foreground)] outline-none focus:border-[color:var(--accent)]"
          />
          <select
            value={currencyInput}
            onChange={(event) => onCurrencyChange(event.target.value as GiftCurrency)}
            className="w-32 rounded-xl border border-[color:var(--field-border)] bg-[color:var(--surface)] px-3 py-3 text-sm text-[color:var(--foreground)] outline-none focus:border-[color:var(--accent)]"
          >
            <option value="USD">USD</option>
            <option value="Riel">Riel</option>
          </select>
        </div>
        {inputError ? <p className="mt-2 text-xs text-red-500">{inputError}</p> : null}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            data-tab-trigger="true"
            onClick={onCancel}
            className="rounded-full border border-[color:var(--field-border)] bg-[color:var(--surface)] px-4 py-2 text-xs font-semibold uppercase tracking-widest text-[color:var(--foreground)] transition hover:bg-[color:var(--surface-hover)]"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            data-tab-trigger="true"
            onClick={onSave}
            className="rounded-full bg-[color:var(--accent)] px-4 py-2 text-xs font-semibold uppercase tracking-widest text-white transition hover:brightness-110"
          >
            {saveLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
